import React from 'react';
import { Grid, TextField } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { TextFieldNumber } from 'ui-component';

const FormPlantilla = ({ data, ctl }) => {
    const {
        register,
        formState: { errors },
        control
    } = useFormContext();

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <TextField
                    id="txt-tit-plantilla"
                    label="Título *"
                    size="small"
                    fullWidth
                    {...register('titulo', {
                        required: { value: true, message: 'Campo requerido' },
                        validate: (value) => value.match(/(^\s+|\s+$)/g) == null || 'El inicio o el final no pueden ser espacios'
                    })}
                    error={Boolean(errors.titulo)}
                    helperText={errors.titulo?.message}
                    defaultValue={data?.titulo}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    id="txt-tipo-plantilla"
                    label="Tipo de material *"
                    size="small"
                    fullWidth
                    select
                    SelectProps={{ native: true }}
                    disabled={Boolean(data?.idTipoActividad)}
                    {...register('idTipoActividad', {
                        required: { value: !data?.idTipoActividad, message: 'Campo requerido' }
                    })}
                    error={Boolean(errors.idTipoActividad)}
                    helperText={errors.idTipoActividad?.message}
                    defaultValue={data?.idTipoActividad || ''}
                >
                    <option value="" />
                    {(ctl?.tiposMaterial || []).map((tipo) => (
                        <option key={tipo.idTipoActividad} value={tipo.idTipoActividad}>
                            {tipo.ntipoActividad}
                        </option>
                    ))}
                </TextField>
            </Grid>
            <Grid item xs={12}>
                <TextFieldNumber
                    id="txt-num-dia-plantilla"
                    label="Días para liberar (opcional)"
                    name="diasHabilitar"
                    defaultValue={data?.diasHabilitar}
                    suffix=" días"
                    control={control}
                    rules={{}}
                />
            </Grid>
        </Grid>
    );
};

export default FormPlantilla;
